import template from "./cross_sell_call_out.html";
import en from "./en.json";
import es from "./es.json";

export default {
    template: template,
    bindings: {
        show: "<",
        state: "@",
        label: "@",
    },
    name: "crossSellCallOut",
    translations: { en, es },
};
